import { useGetCompanyNameLazyQuery } from '@contract-root/admin-react/src/generated/graphql';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  StyledMenu,
  StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import { useGetStandardLetterLazyQuery } from 'generated/graphql';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';

export const StandardLetterListing = (props: any) => {
  const { mode } = props;
  const { pageMode: urlPageMode, companyID }: any = useParams();

  const pageMode = urlPageMode ?? 'client-account';

  let history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);
  const [combinedTemplates, setCombinedTemplates] = useState([]);
  const [loadingAll, setLoadingAll] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Create separate query hooks for each category
  const [
    fetchClientAccount,
    { loading: loadingClient, data: clientData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchCostAdjustment,
    { loading: costAdjustmentLoading, data: costAdjustmentData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchSubcontractor,
    { loading: loadingSubcontractor, data: subcontractorData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchSubcontract,
    { loading: loadingSubcontract, data: subcontractData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchSupplier,
    { loading: loadingSupplier, data: supplierData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchProjectPurchase,
    { loading: loadingProject, data: projectData },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  // Single query for general-settings mode
  const [
    fetchStdLetter,
    {
      loading: standardLetterLoading,
      data: { getStandardLetter } = { getStandardLetter: [] },
    },
  ] = useGetStandardLetterLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchCompany,
    { loading: companyLoading, data: { getCompany } = { getCompany: [] } },
  ] = useGetCompanyNameLazyQuery({
    fetchPolicy: 'network-only',
    variables: { companyID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  // Menu options for dropdown
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'client-account', label: smallTitle.CLIENT_ACCOUNTS },
    { value: 'subcontractor', label: smallTitle.SUBCON_ACCOUNTS },
    { value: 'subcontract', label: smallTitle.SUB_CONTRACT_MANAGEMENT },
    { value: 'supplier', label: smallTitle.SUPPLIER_ACCOUNTS },
    { value: 'client-contract', label: smallTitle.PROJECT_PURCHASES },
    { value: 'project-costing', label: smallTitle.PROJECT_COSTING },
  ];

  const getCategoryLabel = (value: string) => {
    return (
      categoryOptions.find(option => option.value === value)?.label ||
      'All Categories'
    );
  };

  let headerTitle: string = '';
  if (mode === 'company-setup') {
    headerTitle = '';
  } else {
    switch (pageMode) {
      case 'client-account':
        headerTitle = smallTitle.CLIENT_ACCOUNTS;
        break;
      case 'subcontractor':
        headerTitle = smallTitle.SUBCON_ACCOUNTS;
        break;
      case 'subcontract':
        headerTitle = smallTitle.SUB_CONTRACT_MANAGEMENT;
        break;
      case 'supplier':
        headerTitle = smallTitle.SUPPLIER_ACCOUNTS;
        break;
      case 'client-contract':
        headerTitle = smallTitle.PROJECT_PURCHASES;
        break;
      case 'project-costing':
        headerTitle = smallTitle.PROJECT_COSTING;
        break;
      default:
        headerTitle = smallTitle.PRODUCT;
        break;
    }
  }

  // Dropdown handlers
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCategorySelect = (category: string) => {
    setSelectedCategory(category);
    handleMenuClose();
  };

  useEffect(() => {
    if (mode === 'company-setup') {
      // For company-setup mode, fetch all categories individually
      setLoadingAll(true);
      fetchClientAccount({ variables: { letterCategory: 'CLIENT_ACCOUNT' } });
      fetchSubcontractor({
        variables: { letterCategory: 'SUBCONTRACTOR_ACCOUNT' },
      });
      fetchSubcontract({
        variables: { letterCategory: 'SUB_CONTRACT_MANAGEMENT' },
      });
      fetchSupplier({ variables: { letterCategory: 'SUPPLIER_ACCOUNT' } });
      fetchCostAdjustment({
        variables: { letterCategory: 'PROJECT_COSTING' },
      });
      fetchProjectPurchase({
        variables: { letterCategory: 'PROJECT_PURCHASE' },
      });
    } else {
      // For general-settings mode, filter by pageMode as before
      if (pageMode === 'client-account') {
        fetchStdLetter({ variables: { letterCategory: 'CLIENT_ACCOUNT' } });
      } else if (pageMode === 'subcontract') {
        fetchStdLetter({
          variables: { letterCategory: 'SUB_CONTRACT_MANAGEMENT' },
        });
      } else if (pageMode === 'subcontractor') {
        fetchStdLetter({
          variables: { letterCategory: 'SUBCONTRACTOR_ACCOUNT' },
        });
      } else if (pageMode === 'supplier') {
        fetchStdLetter({ variables: { letterCategory: 'SUPPLIER_ACCOUNT' } });
      } else if (pageMode === 'project-costing') {
        fetchStdLetter({ variables: { letterCategory: 'PROJECT_COSTING' } });
      } else if (pageMode === 'client-contract') {
        fetchStdLetter({ variables: { letterCategory: 'PROJECT_PURCHASE' } });
      }
    }

    if (mode === 'company-setup') {
      fetchCompany({ variables: { companyID } });
    }
  }, [pageMode, mode, companyID]);

  // Combine all templates when all category data is available
  useEffect(() => {
    if (
      mode === 'company-setup' &&
      clientData &&
      costAdjustmentData &&
      subcontractorData &&
      subcontractData &&
      supplierData &&
      projectData
    ) {
      const allTemplates = [
        ...(clientData.getStandardLetter || []),
        ...(costAdjustmentData.getStandardLetter || []),
        ...(subcontractorData.getStandardLetter || []),
        ...(subcontractData.getStandardLetter || []),
        ...(supplierData.getStandardLetter || []),
        ...(projectData.getStandardLetter || []),
      ];

      // Remove duplicates based on ID
      const uniqueTemplates = allTemplates.filter(
        (template, index, self) =>
          index === self.findIndex(t => t.ID === template.ID),
      );

      setCombinedTemplates(uniqueTemplates);
      setLoadingAll(false);
    }
  }, [
    clientData,
    costAdjustmentData,
    subcontractorData,
    subcontractData,
    supplierData,
    projectData,
    mode,
  ]);

  // Filter templates based on selected category for company-setup mode
  const getFilteredTemplates = () => {
    if (mode !== 'company-setup') {
      return getStandardLetter;
    }

    switch (selectedCategory) {
      case 'client-account':
        return clientData?.getStandardLetter || [];
      case 'subcontractor':
        return subcontractorData?.getStandardLetter || [];
      case 'subcontract':
        return subcontractData?.getStandardLetter || [];
      case 'supplier':
        return supplierData?.getStandardLetter || [];
      case 'client-contract':
        return projectData?.getStandardLetter || [];
      case 'project-costing':
        return costAdjustmentData?.getStandardLetter || [];
      case 'all':
      default:
        return combinedTemplates;
    }
  };

  const displayTemplates = getFilteredTemplates();
  const isLoading =
    mode === 'company-setup'
      ? loadingAll ||
        loadingClient ||
        loadingSubcontractor ||
        loadingSubcontract ||
        loadingSupplier ||
        costAdjustmentLoading ||
        loadingProject
      : standardLetterLoading;

  return (
    <>
      {companyLoading && <Loading />}
      {isLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname:
              mode === 'general-settings'
                ? `/${pageMode}/general-settings`
                : `/company-setup/submenu/${companyID}`,
          });
        }}
        smTitle={headerTitle}
        title={
          mode === 'general-settings' ? user?.accountName : user?.companyName
        }
        routeSegments={
          mode === 'general-settings'
            ? [
                { name: 'System Admin' },
                { name: 'System Admin' },
                { name: 'Document Template', current: true },
              ]
            : [
                { name: 'System Admin' },
                { name: 'Company Document Template', current: true },
              ]
        }
      />

      {mode === 'company-setup' ? (
        <>
          <DynamicSubHeader
            title={getCompany[0]?.Name}
            rightText={getCompany[0]?.CompanyRegNo}
            infoLine={getCategoryLabel(selectedCategory)}
            infoLineHandleClick={handleMenuClick}
            infoLineDropDownOptions={
              <StyledMenu
                id="category-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {categoryOptions.map(option => (
                  <StyledMenuItem
                    key={option.value}
                    selected={option.value === selectedCategory}
                    onClick={() => {
                      handleCategorySelect(option.value);
                      handleMenuClose();
                    }}
                  >
                    <ListItemText primary={option.label} />
                  </StyledMenuItem>
                ))}
              </StyledMenu>
            }
          />
          <div style={{ paddingBottom: '10px' }} />
        </>
      ) : null}

      <ContentWrapper
        singleDynamicInfo={mode === 'company-setup' ? true : false}
      >
        {!isLoading && displayTemplates?.length === 0 ? (
          <EmptyList
            title="No Document Template"
            subtitle="Please create new Document Template"
          />
        ) : (
          <List className="core-list">
            {displayTemplates?.map((v, i) => (
              <ListItem
                key={v?.ID || i}
                onClick={() =>
                  history.push({
                    pathname:
                      mode === 'general-settings'
                        ? `/${pageMode}/general-settings/standard-letter/${v?.ID}/letter-template`
                        : `/company-setup/submenu/${companyID}/standard-letter/${v?.ID}/letter-template`,
                  })
                }
              >
                <ListItemText
                  primary={<div className="xsTitle">{v?.name}</div>}
                  secondary={
                    <span className="desc">
                      {mode === 'company-setup'
                        ? v?.companyLetterTemplateSubscription?.filter(
                            x =>
                              x?.companyID === companyID &&
                              x?.commonStatus === 'ACTIVE',
                          )?.length ?? 0
                        : v?.letterTemplateSubscription?.length ?? 0}{' '}
                      Template(s)
                    </span>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete">
                    <KeyboardArrowRight
                      onClick={() =>
                        history.push({
                          pathname:
                            mode === 'general-settings'
                              ? `/${pageMode}/general-settings/standard-letter/${v?.ID}/letter-template`
                              : `/company-setup/submenu/${companyID}/standard-letter/${v?.ID}/letter-template`,
                        })
                      }
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
